import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../services/api.service';
import { FileUploadComponent } from '../../../../../common/file-upload/file-upload.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AnagraficaRubrica, ConfigurazioneAccreditamenti, Evento } from '../../../../../shared/interface';

@Component({
  selector: 'app-add-subappalto-accrediti-backoffice',
  templateUrl: './add-subappalto-accrediti-backoffice.component.html',
  styleUrls: ['./add-subappalto-accrediti-backoffice.component.css']
})
export class AddSubappaltoAccreditiBackofficeComponent implements OnInit {

  constructor(
    private apiService: ApiService,    
  ) {}

  @ViewChild('uploadVisuraCamerale', { static: false }) uploadVisuraCamerale!: FileUploadComponent;
  @ViewChild('uploadPos', { static: false }) uploadPos!: FileUploadComponent;

  @Input() visible: boolean = false;
  @Input() evento?: Evento;
  
  @Output() close = new EventEmitter<boolean>();  
  
  formSubappalto!: FormGroup;
  configurazione?: ConfigurazioneAccreditamenti;
  rubrica: AnagraficaRubrica[] = [];
  rubricaSel: AnagraficaRubrica | null = null;
  rubricaVisura = '';
  rubricaPos = '';

  ngOnInit(): void {
    this.formSubappalto = new FormGroup({
      ragione_sociale: new FormControl(null, Validators.required),
      piva: new FormControl(null, Validators.required),
      attivita: new FormControl(null, Validators.required),      
      responsabilita: new FormControl(null, Validators.required),
      visura_camerale: new FormControl(null, Validators.required),
      pos: new FormControl(null, Validators.required),
      pos_dovuto: new FormControl(true),
    });

    this.apiService.getConfigurazioneAccreditamenti().subscribe({
      next: (c) => this.configurazione = c,
      error: () => {},
    });

    this.apiService.getRubrica().subscribe({
      next: (list) => {
        this.rubrica = (list || [])
          .slice()
          .sort((a, b) => (a.ragione_sociale || '').localeCompare(b.ragione_sociale || '', 'it'));
      },
      error: () => { this.rubrica = []; },
    });

    if (!this.evento?.obbligatorieta) {
      this.formSubappalto.get('visura_camerale')?.removeValidators(Validators.required);
      this.formSubappalto.get('pos')?.removeValidators(Validators.required);
    }
    this.syncPosRequired();
  }

  onRubrica(sel: AnagraficaRubrica | null) {
    this.rubricaSel = sel;
    if (!sel) {
      this.rubricaVisura = '';
      this.rubricaPos = '';
      return;
    }
    this.formSubappalto.patchValue({
      ragione_sociale: sel.ragione_sociale || '',
      piva: sel.piva || '',
    });
    this.rubricaVisura = (sel.visura_camerale || '').toString().trim();
    this.rubricaPos = (sel.pos || sel.dvr || '').toString().trim();
    // Ref da rubrica soddisfa l’obbligo file finché non si carica un upload nuovo
    if (this.rubricaVisura) {
      this.formSubappalto.get('visura_camerale')?.removeValidators(Validators.required);
      this.formSubappalto.get('visura_camerale')?.updateValueAndValidity();
    }
    if (this.rubricaPos) {
      this.formSubappalto.get('pos')?.removeValidators(Validators.required);
      this.formSubappalto.get('pos')?.updateValueAndValidity();
    }
  }

  get posObbligatorio(): boolean {
    return !!this.formSubappalto?.get('pos_dovuto')?.value;
  }

  syncPosRequired() {
    const due = !!this.formSubappalto.get('pos_dovuto')?.value;
    const obbl = !!this.evento?.obbligatorieta;
    if (obbl && due) this.formSubappalto.get('pos')?.addValidators(Validators.required);
    else this.formSubappalto.get('pos')?.removeValidators(Validators.required);
    this.formSubappalto.get('pos')?.updateValueAndValidity();
  }

  onClose() {
    this.visible = false;    
    this.close.emit(this.visible);
  }

  onDocumento(documento: string) {
    this.apiService.openProtectedFile(documento);
  }

  onAdd() {

    let subappalto = new FormData();
    
    subappalto.append("id_evento", (this.evento?.id! || 0).toString());
    subappalto.append('ragione_sociale', this.formSubappalto.get('ragione_sociale')?.value || '');
    subappalto.append('piva', this.formSubappalto.get('piva')?.value || '');
    subappalto.append('attivita', this.formSubappalto.get('attivita')?.value || '');    
    subappalto.append('visura_camerale', this.formSubappalto.get('visura_camerale')?.value || '');
    subappalto.append('pos', this.formSubappalto.get('pos')?.value || '');
    subappalto.append('pos_dovuto', this.formSubappalto.get('pos_dovuto')?.value ? '1' : '0');
    if (!this.formSubappalto.get('visura_camerale')?.value && this.rubricaVisura) {
      subappalto.append('visura_camerale_ref', this.rubricaVisura);
    }
    if (!this.formSubappalto.get('pos')?.value && this.rubricaPos) {
      subappalto.append('pos_ref', this.rubricaPos);
    }
    
    this.apiService.addSubappalto(subappalto).subscribe({
      next: (data) => {
        this.apiService.setSubappaltiEvento(this.evento?.id!);
        this.apiService.setDocumentiEvento(this.evento?.id!);
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.uploadVisuraCamerale.clearUpload();
        this.uploadPos.clearUpload();

        this.formSubappalto.reset({ pos_dovuto: true });
        this.rubricaSel = null;
        this.rubricaVisura = '';
        this.rubricaPos = '';
        this.formSubappalto.markAsUntouched();
        this.formSubappalto.markAsPristine();    
        this.syncPosRequired();

        this.onClose()
      }
    });    

  }

}
